import React from 'react';
import { connect } from 'react-redux';
import { InfoBar } from 'ctia-ui';

const TestResultsInfoBar = ({ request }) => {
  const { modelName, vendor } = request;
  const reqInfo = [
    {
      key: 'Manufacturer',
      value: vendor
    },
    {
      key: 'Model Name/Number',
      value: modelName
    },
    {
      key: 'Test Module',
      value: 'WINNF-TS-0122'
    }
  ];

  return <InfoBar show={true} data={reqInfo} />;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(TestResultsInfoBar);



// WEBPACK FOOTER //
// ./src/containers/TestResultsInfoBar.js